import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent, RegisterComponent, VerficationComponent, ForgetPasswordComponent, ResetPasswordComponent } from './index';
import { AuthService } from './service/auth.service';
import { AuthGuardService, RoleGuardService } from './service/auth-guard.service';
import { UserRegistrationService, UserLoginService, UserParametersService, CognitoUtil } from './service/cognito.service';
import { EqualValidator } from './equal-validator.directive';
import { NotFoundComponent } from './not-found/not-found.component';
import {CheckboxModule} from 'primeng/checkbox';
import { environment } from '../../environments/environment';
// Import your library
import { NgxStripeModule } from 'ngx-stripe';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    CheckboxModule,
    TranslateModule,
    NgxStripeModule.forRoot(environment.stripeKey),

  ],
  declarations: [LoginComponent, RegisterComponent, VerficationComponent, ForgetPasswordComponent,
    ResetPasswordComponent, EqualValidator, NotFoundComponent],
  providers: [AuthService, AuthGuardService, RoleGuardService,
    UserRegistrationService, UserLoginService, UserParametersService, CognitoUtil]
})
export class AuthenticationModule { }



// WEBPACK FOOTER //
// ./src/app/authentication/authentication.module.ts